export default "__VITE_PUBLIC_ASSET__408ee5d1__"